export const devlog_entries = [
  {
    id: 1,
    url: "/devlog/devlog-1",
    title: "Project Introduction",
    date: "2026-10-04",
    description:
      "In this Devlog I will discuss my initial journey into the world of tile-based textures, shaders and texture blending.",
    tags: [
      "Unity",
      "Dungeon Crawler",
      "Turn-Based",
      "Top-Down",
      "3D",
      "C#",
      "Game Development",
      "Procedural Generation",
    ],
    // Tags marked true render highlighted (green border)
    highlights: ["C#", "Unity", "Game Development"],
    blocks: [
      {
        type: "text",
        content:
          "Since I am new to game dev especially the more technical end, and I, of course dove headfirst into an overly ambitious set of features to work on. I am mostly interested in tile-based strategy games. But a feature I really wanted to learn how to implement that I have seen in many is the terrain system. But I didn’t want to use a ready to go feature like unity terrain, I wanted more control over the feature. Let’s say for example being able to change a tile texture at runtime. Since I’m not a full time dev I spent around the next year researching the topic and creating vertex planes, creating experimental g ames to try out the feature.",
      },
    ],
  },
];
